<template>
	<iframe
		src="https://feedback.userreport.com/56cb473e-26aa-4b35-8f39-7de31f062b3b/#ideas/popular"
		class="w-full h-full"
	/>
</template>